module.exports = __webpack_public_path__ + "static/img/index_item6_bg.4c6d318.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/index_item6_bg.png
// module id = X+wY
// module chunks = 0